export const initialDebug = {
    errorCode: '',
    message: '',
}